import Crud from '../views/Manufacturer/Crud'
import Entity from '../views/Manufacturer/Add'

let routes = {
    path: '/manufacturers',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/manufacturers/add',
            name: 'NewManufacturer',
            component: Entity,
            meta: {
                pageTitle: 'Fabricante',
                breadcrumb: [
                    { text: 'Fabricante', active: false, to: '/manufacturers' },
                    { text: 'Adicionar Fabricante', active: true }
                ],
            },
        },
        {
            path: '/manufacturers/edit/:id?',
            name: 'EditManufacturer',
            component: Entity,
            meta: {
                pageTitle: 'Fabricante',
                breadcrumb: [
                    { text: 'Fabricante', active: false, to: '/manufacturers' },
                    { text: 'Editar Fabricante', active: true }
                ],
            },
        },
        {
            path: '/manufacturers',
            name: 'list-manufacturers',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Fabricante', active: true },
                ],
            },
        },
    ]
};

export default routes
